<template>
  <div>
    <transition name="fade">
      <div class="zoom-lightbox" v-on:click="handleClose" v-show="lbVisible">
        <div class="centralizer">
          <transition name="fscale">
            <div class="zoom-holder" v-show="zoomVisible" ref="zholder" :class="{transable: changing}" >
              <div class="close-box" v-on:click="handleCloseManual"></div>
              <div class="arrow-left" v-on:click="$emit('prev')"></div>
              <div class="arrow-right" v-on:click="$emit('next')"></div>
              <div class="zoom-flex" v-touch:swipe.left="swipeLeftHandler" v-touch:swipe.right="swipeRightHandler">
                <drag-image :src="imgsrc" v-on:zoom="setZoomed" :zoom="zoomed" v-if="!isAnimation" />
                <zoom-animation :image="mimage" :artist="martist" v-if="isAnimation" autoplay />
                <image-description-panel :artist="martist" :image="mimage" />
              </div>
              <router-link class="permalink" :to="permalink" title="permalink"></router-link>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DragImage from './DragImage.vue'
import ImageDescriptionPanel from '@/components/panels/ImageDescriptionPanel.vue'
import ZoomAnimation from '@/components/panels/ZoomAnimation.vue'
const DELAY = 50

export default {
  components: {
    DragImage,
    ImageDescriptionPanel,
    ZoomAnimation
  },
  props: {
    visible: Boolean,
    image: Object,
    artist: Object
  },
  data () {
    return {
      zoomVisible: false,
      lbVisible: false,
      hideImage: false,
      changing: false,
      mimage: { detail: {}, galleries: [] },
      zoomed: false,
      url: '',
      media: '',
      isAnimation: false,
      martist: {}
    }
  },
  created: function () {
    if(this.image) {
      this.mimage = this.image
      this.isAnimation = this.mimage.animation
      
    }
  },
  mounted () {
    window.addEventListener('keydown', (e) => {
      if(e.code === this.$k.prevkey) {
        this.$emit('prev')
      }
      else if(e.code === this.$k.nextkey){
        this.$emit('next')
      }
    })
  },
  computed: {
    
    imgsrc: function () {
      if(this.mimage.url) {
        return this.$k.getZoomImage(this.mimage.url)
      }
      return ''
    },
    permalink: function () {
      if(this.mimage.url) {
        return this.$k.getImagePermalink(this.mimage, this.artist)
      }
      return ''
    }
  },
  methods: {
    async setArtist () {
      if(this.artist) {
        this.martist = this.artist
      }
      else {
        this.martist = await this.$store.dispatch('fetchArtistById', this.image.artist_id)
      }
    },
    swipeLeftHandler () {
      this.$emit('prev')
    },
    swipeRightHandler () {
      this.$emit('next')
    },
    setZoomed: function (val) {
      this.zoomed = val
    },
    handleOpen: async function () {
      this.$store.commit('setStopPreviews', true)
      this.lbVisible = true
      if(this.mimage) this.isAnimation = this.mimage.animation
      await this.$k.waitfor(DELAY)
      this.zoomVisible = true
    },
    handleClose: async function (e) {
      if(this.$refs.zholder) {
        if(this.$refs.zholder.contains(e.target)){
          return
        }
      }
      this.handleCloseManual()
    },
    handleCloseManual: async function () {
      this.$store.commit('setStopPreviews', false)
      this.lbVisible = false
      this.zoomVisible = false
      if(this.$refs.zholder) {
        this.$refs.zholder.style.height = 'auto'
        this.$refs.zholder.style.width = 'auto'
      }
      this.isAnimation = false
      this.$emit('close')
    },
    handleImageChange: async function () {
      await this.setArtist()
      if(this.image.animation) {
        this.$refs.zholder.style.height = 'auto'
        this.$refs.zholder.style.width = 'auto'
        this.mimage = this.image
        this.isAnimation = true
        return;
        
      }
      this.zoomed = false
      this.isAnimation = false
      this.changing = false;
      let oldh = this.$refs.zholder.offsetHeight
      let oldw = this.$refs.zholder.offsetWidth
      this.hideImage = true;
      this.mimage = this.image
      this.isAnimation = this.image.animation
      
      let url = this.$k.getZoomImage(this.image.url)
      await this.$k.loadImage(url)
    
      this.hideImage = false
      let newh = 0
      let neww = 0
      if(oldh > 0) {
        this.$refs.zholder.style.height = 'auto'
        this.$refs.zholder.style.width = 'auto'
        newh = this.$refs.zholder.offsetHeight
        neww = this.$refs.zholder.offsetWidth
        this.$refs.zholder.style.height = oldh + 'px'
        this.$refs.zholder.style.width = oldw + 'px'
        this.$refs.zholder.offsetHeight // this is really important, weirdly
        this.changing = true
      }
      this.$nextTick(() => {
        
        if(oldh > 0) {
          this.$refs.zholder.style.height = newh + 'px'
          this.$refs.zholder.style.width = neww + 'px'
          this.$refs.zholder.offsetHeight // this is really important, weirdly
        }
        this.$k.waitfor(300).then(() => {
          this.changing = false
        })
      })
      
      
    }
  },
  watch: {
    visible: function () {
      if(this.visible){
        this.handleOpen()
      }
    },
    image: function () {
      if(this.image) {
        this.handleImageChange()
      }
    }
  }
}
</script>

<style scoped>



.social-panel{
  margin-top: 70px;
  margin-bottom: 16px;
}

a.permalink{
  width:14px;
  height:14px;
  background-repeat: no-repeat;
  background-image: url('../../assets/img/circle-gold.svg');
  background-size: contain;
  cursor:pointer;
  opacity:0.5;
  display:block;
  position:absolute;
  bottom:10px;
  right:10px;
}

.permalink:hover{
  opacity:0.9;
  background-image: url('../../assets/img/circle.svg');
}

.transable{
  transition: all 0.15s ease;
}



.zoom-holder{
  background-color:#fff;
  padding:40px;
  z-index:510;
  min-width:200px;
  min-height:200px;
  box-sizing:border-box;
  max-height:99vh;
  overflow-y:auto;
  /*overflow:hidden;*/
}


.zoom-flex{
  display:flex;
  justify-content:space-between;
  cursor:default;
}


.close-box{
  opacity:0.3;
  top:20px;
  right:20px;
}

.close-box:hover{
  opacity:1.0;
}



.arrow-left, .arrow-right{
  position:absolute;
  top:50%;
  transform:translate(0,-50%);
  background-repeat:no-repeat;
  background-size:contain;
  width:75px;
  height:136px;
  opacity:0;
  transition:opacity 0.4s ease;
}

.zoom-holder:hover .arrow-left{
  opacity:0.4;
}

.zoom-holder:hover .arrow-right{
  opacity: 0.2;
}

.arrow-left{
  left:50px;
  background-image:url('../../assets/img/arrow-left.svg');
  z-index:50;
}

.arrow-right{
  
  right:30px;
  background-image:url('../../assets/img/arrow-right.svg')
}

.zoom-holder:hover .arrow-left:hover{
  opacity:0.7;
}

.zoom-holder:hover .arrow-right:hover{
   opacity: 0.3;
 }

@media screen and (max-width:960px){
  .zoom-flex{
    flex-direction: column;
  }
  .zoom-holder{
    padding:10px;
  }

  .arrow-left, .arrow-right{
    display:none;
  }
}

</style>
